<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Giftcards</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a></li>
                            <li class="breadcrumb-item">
                                <Link :href="route('admin.giftcards.index')">
                                    Giftcards
                                </Link>
                            </li>
                            <li class="breadcrumb-item active">Create Giftcard</li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-body">
                    <form @submit.prevent="saveGiftcard">
                        <div class="row">
                            <div class="col-12 col-sm-6">
                                <div class="form-group mb-1">
                                    <label for="customer-search">Sender<span class="text-danger">*</span></label>
                                    <v-select
                                        id="customer-search"
                                        class="customer-search"
                                        label="name"
                                        v-model="giftcard.sender"
                                        :filterable="false"
                                        :options="customers"
                                        @search="onSearch"
                                    >
                                        <template slot="no-options">Search by phone number</template>
                                        <template slot="option" slot-scope="option">
                                            <div class="d-center">
                                                <small>{{ option.email }}, {{ option.phone }}</small>
                                                <br>
                                                <span>{{ option.first_name + ' ' + option.last_name }}</span>
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                            <div class="selected d-center">
                                                <span>{{ option.first_name + ' ' + option.last_name + '(₦' + option.balance + ')' }}</span>
                                            </div>
                                        </template>
                                    </v-select>
                                    <div v-if="giftcard.errors.sender_id" class="text-danger text-small">
                                        {{ giftcard.errors.sender_id }}
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="controls">
                                        <label>Receiver Name<span class="text-danger">*</span></label>
                                        <input
                                            v-model="giftcard.name"
                                            class="form-control"
                                            type="text"
                                            placeholder="Receiver Name"
                                            required
                                        >
                                        <div v-if="giftcard.errors.name" class="text-danger text-small">
                                            {{ giftcard.errors.name }}
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="controls">
                                        <label>Giftcard Message</label>
                                        <textarea
                                            v-model="giftcard.message"
                                            class="form-control"
                                            cols="30"
                                            rows="10"
                                        />
                                        <div v-if="giftcard.errors.message" class="text-danger text-small">
                                            {{ giftcard.errors.message }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <div class="controls">
                                        <label>Receiver Email<span class="text-danger">*</span></label>
                                        <input
                                            v-model="giftcard.email"
                                            class="form-control"
                                            type="text"
                                            placeholder="Receiver Email Address"
                                            required
                                        >
                                        <div v-if="giftcard.errors.email" class="text-danger text-small">
                                            {{ giftcard.errors.email }}
                                        </div>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <div class="controls">
                                        <label>Giftcard Amount<span class="text-danger">*</span></label>
                                        <input
                                            v-model="giftcard.amount"
                                            class="form-control"
                                            type="number"
                                            placeholder="Giftcard Amount"
                                            required
                                        >
                                        <div v-if="giftcard.errors.amount" class="text-danger text-small">
                                            {{ giftcard.errors.amount }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-1">
                                <button
                                    type="submit"
                                    class="btn btn-primary glow mb-1 mb-sm-0 mr-0 mr-sm-1"
                                    :disabled="saving"
                                >
                                    Save
                                    <i v-if="saving" class="fa fa-spinner fa-spin"/>
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';
import {Link} from '@inertiajs/vue2';

export default {
    metaInfo: {title: 'Create Giftcard'},
    name: 'GiftcardCreate',
    components: {
        Link,
    },
    layout: Layout,
    data() {
        return {
            giftcard: this.$inertia.form({
                email: null,
                name: null,
                sender: null,
                amount: null,
                message: null,
                sender_id: null,
            }),
            saving: false,
            customers: [],
        };
    },
    methods: {
        async saveGiftcard() {
            this.saving = true;

            const options = {
                preserveScroll: true,
                onSuccess: () => {
                    this.saving = false;
                },
                onError: () => {
                    this.saving = false;
                },
            };

            this.giftcard.sender_id = this.giftcard.sender?.id;
            this.giftcard.post(route('admin.giftcards.store'), options);
        },

        onSearch(search, loading) {
            if (search.length >= 3) {
                loading(true);
                this.search(loading, search, this);
            }
        },

        search: _.debounce((loading, search, vm) => {
            axios.get(route('admin.customers.search', {
                keyword: search.trim(),
            })).then(({data: {data}}) => {
                vm.customers = data;
                loading(false);
            });
        }, 1000),
    },
};
</script>
